<template>
    <loading/>
  <div class="container-fluid">
    <Navigation/>
    <div class="main " >
     <topbar/>
      <slot/>
    </div>
  </div>
</template>
<script>
import Navigation from '@/panel/components/Layout/navigation.vue'
import topbar from '@/panel/components/Layout/topbar.vue'
import loading from "@/panel/components/loading/index.vue";
export default {
  name: "index",
  components: {
    Navigation, topbar ,loading
  },
}
</script>

<style scoped>

</style>